import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './CollapsibleSection.html?raw';
class CollapsibleSection extends compose(_WidgetBaseSP) {
    templateString: any = template;
    isCollapsed: boolean = true;
    isEditable: boolean = true;

    sectionName: string = "default";

    collapsibleSection: HTMLElement;
    collapsibleHeadingContainer: HTMLElement;
    collapsibleCollapseContainer: HTMLElement;
    collapsibleIcon: HTMLElement;
    collapsibleHeading: HTMLElement;
    collapsibleContainer: HTMLElement;
    collapsibleAnimationContainer: HTMLElement;
    collapsibleAnimationnBar: HTMLElement;

    collapsibleButtonContainer: HTMLElement;
    btnEdit: HTMLElement;
    collapsibleErrorContainer: HTMLElement;
    collapsibleErrorMessage: HTMLElement;

    collapsibleSectionEditFunction: Function = function(name) { alert(name) };

    private _onClickCollapsibleSection(evt: MouseEvent) {
        
        this.toggleCollapse();
    }

    private toggleCollapse(): void {
        if (this.isCollapsed == true) {
            this.expandSection();
        } else {
            this.collapseSection();
        }
    }

    collapseSection() {
        this.isCollapsed = true;
        this.setCollapseStyle();
    }

    expandSection() {
        this.isCollapsed = false;
        this.setCollapseStyle();
    }

    private setCollapseStyle() {
        
        if (this.isCollapsed == true) {

            this.UiModder.domClass.remove(this.collapsibleIcon, "fa-rotate-90");

            this.UiModder.domClass.add(this.collapsibleContainer, "w3-hide");
            this.UiModder.domClass.add(this.collapsibleButtonContainer, "w3-hide");
            this.UiModder.domClass.add(this.btnEdit, "w3-hide w3-disabled");

            this.UiModder.domClass.add(this.collapsibleErrorContainer, "w3-hide");
        } else {

            this.UiModder.domClass.add(this.collapsibleIcon, "fa-rotate-90");
            this.UiModder.domClass.remove(this.collapsibleContainer, "w3-hide");
            this.UiModder.domClass.remove(this.collapsibleButtonContainer, "w3-hide");

            if (this.isEditable == true) {

                this.UiModder.domClass.remove(this.btnEdit, "w3-hide w3-disabled");
            }
        }

        this.emit("CollapsibleSection_isCollapsed", { isCollapsed: this.isCollapsed });
    }

    _onClick_Button_Edit(): void {

        this.collapsibleSectionEditFunction(this.sectionName);
    }

    _showErrorMessage(message: any, show: boolean): void {
        this.StandbyStop();

        this.collapsibleErrorMessage.innerHTML = message;

        this.UiModder.domClass.add(this.collapsibleErrorContainer, "w3-hide");

        if (show) this.UiModder.domClass.remove(this.collapsibleErrorContainer, "w3-hide");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(CollapsibleSection);